import React, { useState, useEffect } from 'react';
import { Button } from '@vaiu/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@vaiu/ui/dropdown-menu";
import { i18n, SUPPORTED_LANGUAGES, SupportedLanguage } from '@/utils/i18n';
import { Check } from 'lucide-react';

const languageFlags: { [key in SupportedLanguage]: string } = {
  en: '🇺🇸',
  es: '🇪🇸',
  fr: '🇫🇷',
  sq: '🇦🇱',
  ru: '🇷🇺',
  pt: '🇵🇹',
  el: '🇬🇷',
  de: '🇩🇪',
  ro: '🇷🇴',
  sr: '🇷🇸',
  pl: '🇵🇱',
};

const CompactLanguageSelector: React.FC = () => {
  const [currentLanguage, setCurrentLanguage] = useState<SupportedLanguage>(i18n.getLanguage());

  useEffect(() => {
    const handleLanguageChange = (event: CustomEvent) => {
      setCurrentLanguage(event.detail);
    };

    window.addEventListener('languageChanged', handleLanguageChange as EventListener);
    return () => {
      window.removeEventListener('languageChanged', handleLanguageChange as EventListener);
    };
  }, []);

  const handleLanguageSelect = (lang: SupportedLanguage) => {
    i18n.setLanguage(lang);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="text-2xl">
          {languageFlags[currentLanguage]}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {Object.entries(SUPPORTED_LANGUAGES).map(([code, name]) => (
          <DropdownMenuItem
            key={code}
            onSelect={() => handleLanguageSelect(code as SupportedLanguage)}
            className="flex items-center justify-between"
          >
            <div className="flex items-center">
              <span className="mr-2">{languageFlags[code as SupportedLanguage]}</span>
              <span>{name}</span>
            </div>
            {currentLanguage === code && <Check className="w-4 h-4" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default CompactLanguageSelector;
